import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { FormField } from '../../FormField/FormField';
import { LOCALES } from '../../../config/locales';
import { Routine } from '../../../types/Fisiofit/routine';
import { MAX_DURATION } from '../constants';
import { RoutineFormFieldProps } from '../types';

type DurationFieldProps = RoutineFormFieldProps & {
  isCreating: boolean;
  isEditing: boolean;
  minDuration: number;
  locale: LOCALES;
  currentRoutine: Routine | undefined;
};

export const DurationField = ({
  form,
  setFormFields,
  validationErrors,
  isCreating,
  isEditing,
  minDuration,
  locale,
  currentRoutine,
}: DurationFieldProps) => {
  return (
    <FormField
      labelTitle='Duración (días)'
      elementId='routine-duration'
      fullWidth
      error={validationErrors?.duration}
      required={isCreating || isEditing}
    >
      {isCreating || isEditing ? (
        <InputNumber
          inputId='routine-duration'
          value={form?.duration}
          onChange={(e) => {
            setFormFields({ duration: e.value !== null ? (e.value < minDuration ? minDuration : e.value) : null });
          }}
          allowEmpty={!isEditing}
          invalid={!!validationErrors?.duration}
          placeholder='Ej: 14'
          showButtons
          min={minDuration}
          locale={locale === 'es' ? 'es-ES' : 'en-US'}
          minFractionDigits={0}
          maxFractionDigits={0}
          max={MAX_DURATION}
        />
      ) : (
        <p>{currentRoutine?.duration} días</p>
      )}
    </FormField>
  );
};
